import React from "react"

const BrandContext = React.createContext({})

export const BrandProvider = BrandContext.Provider
export const BrandConsumer = BrandContext.Consumer
export default BrandContext
